import { render, staticRenderFns } from "./returnAddress.vue?vue&type=template&id=07492247&scoped=true"
import script from "./returnAddress.vue?vue&type=script&lang=js"
export * from "./returnAddress.vue?vue&type=script&lang=js"
import style0 from "./returnAddress.vue?vue&type=style&index=0&id=07492247&prod&lang=scss&scoped=true"
import style1 from "./returnAddress.vue?vue&type=style&index=1&id=07492247&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07492247",
  null
  
)

export default component.exports